module.exports = __webpack_public_path__ + "static/worthy-d503dc634a485fc980bbd33b5fd2c034.mp4";